export const FerramentasHero = () => {
	return (
		<div className="mb-16 text-center space-y-6">
			<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight animate-slide-down">
				Ferramentas
			</h1>
			<p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed animate-slide-up stagger-1">
				Recursos essenciais para profissionais do mercado imobiliário.
				Calculadoras, consultas e ferramentas que otimizam seu trabalho e
				aumentam sua produtividade.
			</p>
		</div>
	);
};
